// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__5F2az","lastWrapper":"index_lastWrapper__4HiXq","icon":"index_icon__Fn46V","hrefHover":"index_hrefHover__qo4VB","textList":"index_textList__mDfud"};